import { defineStore } from 'pinia';

import type { CoreSiteConfigQuery } from '~/graphql/generated/graphql';

export type ClusterRegistryEntry = CoreSiteConfigQuery['core']['org']['clusters'][number];

/**
 * The backend now ships `host` and `pathPrefix` as first-class fields, so the
 * registry consumes them directly — no client-side parsing of a packed string.
 */
export type ResolvedCluster = ClusterRegistryEntry;

export const useClusterRegistryStore = defineStore('clusterRegistry', () => {
  // Returned as state so the SSR payload carries it; config only loads server-side.
  const clusters = ref<ResolvedCluster[]>([]);

  const setClusters = (entries: ClusterRegistryEntry[]) => {
    clusters.value = [...entries];
  };

  const findByCode = (code: string): ResolvedCluster | undefined => {
    return clusters.value.find(c => c.code === code);
  };

  return { clusters, setClusters, findByCode };
});
